import {RouterModule, Routes} from '@angular/router';
import {OCRComponent} from './ocr.component';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConvertFileComponent} from './convert-file/convert-file.component';
import {FormsModule} from '@angular/forms';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

const routes: Routes = [
    {
        path: '',
        component: OCRComponent,
        children: [
            {
                path: 'converteste-fisier',
                component: ConvertFileComponent,
            },
            { path: '', redirectTo: '/', pathMatch: 'full' },
            {
                path: '**',
                redirectTo: '/',
                pathMatch: 'full',
            },
        ],
    },
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        FormsModule,
        MatProgressSpinnerModule
    ],
    declarations: [OCRComponent,
                    ConvertFileComponent]
})

export class OcrModule {

}
